module.exports = __webpack_public_path__ + "static/media/Ellipse3.99a659bb.png";